import React, { useState, useEffect, useRef } from 'react'
import { supabase } from './supabase'
import { uploadToR2 } from './r2'

function Photos() {
  const [photos, setPhotos] = useState([])
  const [uploading, setUploading] = useState(false)
  const [selectedPhoto, setSelectedPhoto] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const fileInput = useRef()

  useEffect(() => {
    fetchPhotos()
  }, [])

  async function fetchPhotos() {
    const { data, error } = await supabase
      .from('photos')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100)
    if (!error && data) setPhotos(data)
  }

  async function handleUpload(e) {
    const files = Array.from(e.target.files)
    if (!files.length) return
    setUploading(true)
    for (const file of files) {
      try {
        const ext = file.name.split('.').pop()
        const path = `photos/${Date.now()}-${Math.random().toString(36).slice(2)}.${ext}`
        const url = await uploadToR2(file, path)
        await supabase.from('photos').insert([{
          name: file.name, url, path,
          created_at: new Date().toISOString(),
        }])
      } catch (err) { console.error('Upload failed:', err) }
    }
    await fetchPhotos()
    setUploading(false)
  }

  async function handleDelete(photo) {
    if (!window.confirm('Delete this photo? This cannot be undone.')) return
    setDeleting(true)
    try {
      // Delete from Supabase table
      await supabase.from('photos').delete().eq('id', photo.id)
      // Delete from Supabase Storage if it's an old photo (no R2 path)
      if (photo.path && !photo.url?.includes('r2.dev')) {
        await supabase.storage.from('photos').remove([photo.path])
      }
      setSelectedPhoto(null)
      fetchPhotos()
    } catch (err) { console.error('Delete failed:', err) }
    setDeleting(false)
  }

  return (
    <div>
      <div className="photos-header">
        <h2>Family Photos</h2>
        <button onClick={() => fileInput.current.click()}>
          {uploading ? 'Uploading...' : 'Add Photos'}
        </button>
        <input
          ref={fileInput}
          type="file"
          accept="image/*"
          multiple
          style={{ display: 'none' }}
          onChange={handleUpload}
        />
      </div>

      {photos.length === 0 ? (
        <div className="photos-empty">
          <p>No photos yet. Click Add Photos to get started.</p>
        </div>
      ) : (
        <div className="photos-grid">
          {photos.map(photo => (
            <div key={photo.id} className="photo-card" onClick={() => setSelectedPhoto(photo)} style={{ cursor: 'pointer' }}>
              <img src={photo.url} alt={photo.name} />
              <p>{photo.name}</p>
              <span>{new Date(photo.created_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      )}

      {selectedPhoto && (
        <div className="lightbox" onClick={() => setSelectedPhoto(null)}>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <img src={selectedPhoto.url} alt={selectedPhoto.name} />
            <p>{selectedPhoto.name}</p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' }}>
              <button onClick={() => setSelectedPhoto(null)}>Close</button>
              <button
                onClick={() => handleDelete(selectedPhoto)}
                disabled={deleting}
                style={{ background: '#ff3b30', color: 'white', border: 'none', borderRadius: '8px', padding: '8px 16px', cursor: 'pointer', fontWeight: '600' }}
              >{deleting ? 'Deleting...' : 'Delete Photo'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Photos
